import { setCookie } from '@bibliocommons/utils-browser';

export default function redirectMiddleware() {
  return next => (action) => {
    if (action.payload && action.payload.forceRedirectURL && __CLIENT__) {
      const PRE_LOGIN_URL_COOKIE = 'pre_login_url';
      setCookie(PRE_LOGIN_URL_COOKIE, window.location.href, { path: '/' });
      window.location.href = action.payload.forceRedirectURL;
    }

    return next(action);
  };
}




// WEBPACK FOOTER //
// ./app/reduxMiddlewares/redirectMiddleware.js